<template>
  <Table>
    <template #thead>
      <TableRow>
        <TableData heading text-align="left">
          {{ $t('rewards.tableHeadTournament') }}
        </TableData>
        <TableData heading>
          {{ $t('rewards.tableHash') }}
        </TableData>
        <TableData heading>
          {{ $t('rewards.tableHeadDates') }}
        </TableData>
        <TableData heading>
          {{ $t('rewards.tableHeadPlace') }}
        </TableData>
        <TableData heading>
          {{ $t('rewards.tableHeadReward') }}
        </TableData>
        <TableData heading>
          {{ $t('rewards.tableHeadStatus') }}
        </TableData>
      </TableRow>
    </template>
    <template #tbody>
      <TableRow v-for="(row, rowIndex) in tableData" :key="rowIndex">
        <TableData text-align="left">
          <RewardsTournament
            :tournament-id="row.tournament.id"
            :tournament-name="row.tournament.name"
            :game-id="row.game.id"
          />
        </TableData>
        <TableData>
          <div class="rewards-table__identifications">
            <RewardsId
              v-if="row.payout.id"
              :id="row.payout.id"
              :title="$t('rewards.payoutId')"
            />
            <RewardsId
              v-if="row.payout.vkId"
              :id="row.payout.vkId"
              :title="$t('rewards.payoutVKId')"
            />
          </div>
        </TableData>
        <TableData>
          {{ createDatetime(row.tournament.startTs) }} -
          {{ createDatetime(row.tournament.finishTs) }}
        </TableData>
        <TableData>
          {{ row.tournament.place }}
        </TableData>
        <TableData>
          <RewardsPayout
            v-if="row.payout.status === 'paid'"
            :payout="row.payout.amountPaid"
            :commission="row.payout.amountFee"
            :total="row.payout.amount"
          />
          <template v-else> {{ row.payout.amount }} ₽ </template>
        </TableData>
        <TableData white-space="normal">
          <RewardsStatus
            :status="row.payout.status"
            :is-payable="isPayable"
          />
        </TableData>
      </TableRow>
    </template>
  </Table>
</template>

<script>
import RewardsTournament from './RewardsTournament.vue';
import RewardsPayout from './RewardsPayout.vue';
import RewardsStatus from './RewardsStatus.vue';
import Table from '@components/v2/ui/Table.vue';
import TableRow from '@components/v2/ui/TableRow.vue';
import TableData from '@components/v2/ui/TableData.vue';
import { createDatetimeString } from '../lib/datetime';
import RewardsId from './RewardsId.vue';

export default {
  name: 'RewardsTable',
  components: {
    RewardsTournament,
    RewardsId,
    RewardsPayout,
    RewardsStatus,
    Table,
    TableRow,
    TableData,
  },

  props: {
    isPayable: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
    };
  },

  methods: {
    createDatetime(timestamp) {
      return createDatetimeString(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  vertical-align: top;
  line-height: 18px;
}
.rewards-table__identifications {
  display: flex;
  gap: 8px;
}
</style>
